(function (angular) {
    angular.module("app", ['ngRoute', 'ngStomp', 'pascalprecht.translate', 'ngCookies', 'ui.bootstrap', 'ngSanitize', 'dndLists', 'chart.js', 'ng-showdown', 'sly', 'ui.tree', 'ngTagsInput']);
})(angular);